export default [
    {
        name: 'fact',
        sortField: 'fact',
        type: 'string',
        useInFilter: true,
        isDefault: true,
        defaultSearch: true
    }

]